import {getField, updateField} from "vuex-map-fields"

export const state = () => ({
    admins : [],
    a_loading : false
})

export const getters = {
    getField,
}

export const mutations = {
    updateField,
}
